import { Thumbmark } from '@thumbmarkjs/thumbmarkjs'
import React, { useEffect } from 'react';

function Fingerprint({setThumbmark}) {
  
    useEffect(() => {
      const tm = new Thumbmark();
      tm.get()
        .then((result) => {
          setThumbmark(result.thumbmark);
          localStorage.setItem("device_fingerprint", result.thumbmark);
        })
        .catch((error) => {
          console.error('Error getting fingerprint:', error);
          setTimeout(() => {
            tm.get()
              .then((result) => {
                setThumbmark(result.thumbmark);
                localStorage.setItem("device_fingerprint", result.thumbmark);
              })
              .catch((retryError) => {
                console.error('Retry failed for fingerprint:', retryError);
              });
          }, 1000);
        });
    }, [setThumbmark]);
    
    return <></>
  }

export default Fingerprint